import { render, staticRenderFns } from "./editCorpSalesTestimonial.vue?vue&type=template&id=6d82b504&"
import script from "./editCorpSalesTestimonial.vue?vue&type=script&lang=js&"
export * from "./editCorpSalesTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports